export default "__VITE_ASSET__f023afce__"